<template>
  <v-dialog :value="value" max-width="400" @input="$emit('input', $event)">
    <v-card class="dc-card">
      <!-- Ícono central -->
      <div class="dc-icon-wrap">
        <div class="dc-icon-circle">
          <v-icon class="dc-icon">{{ icon }}</v-icon>
        </div>
      </div>

      <!-- Texto -->
      <div class="dc-body">
        <h2 class="dc-title">{{ title }}</h2>
        <p class="dc-message">{{ message }}</p>
        <p v-if="itemName" class="dc-item-name">{{ itemName }}</p>
      </div>

      <!-- Acciones -->
      <div class="dc-actions">
        <button
          class="dc-btn dc-btn--cancel"
          :disabled="loading"
          @click="onCancel"
        >
          {{ cancelText }}
        </button>
        <button
          class="dc-btn dc-btn--confirm"
          :class="{ 'is-loading': loading }"
          :disabled="loading"
          @click="onConfirm"
        >
          <span v-if="loading" class="dc-spinner"></span>
          <span v-else>{{ confirmText }}</span>
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogConfirm',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Confirmar acción',
    },
    message: {
      type: String,
      default:
        '¿Estás seguro de que deseas continuar? Esta acción no se puede deshacer.',
    },
    itemName: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'Eliminar',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
    icon: {
      type: String,
      default: 'delete_outline',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
    onCancel() {
      this.$emit('input', false)
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped>
.dc-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding: 0;
}

/* ── Ícono ─────────────────────────────────── */
.dc-icon-wrap {
  display: flex;
  justify-content: center;
  padding: 28px 24px 0;
}

.dc-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #fef2f2;
  border: 5px solid #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dc-icon {
  color: #e5252a !important;
  font-size: 26px !important;
}

/* ── Texto ─────────────────────────────────── */
.dc-body {
  padding: 16px 28px 8px;
  text-align: center;
}

.dc-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
  letter-spacing: -0.01em;
}

.dc-message {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

.dc-item-name {
  margin: 8px 0 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #334155;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 6px 12px;
  display: inline-block;
}

/* ── Botones ────────────────────────────────── */
.dc-actions {
  display: flex;
  gap: 10px;
  padding: 20px 28px 24px;
}

.dc-btn {
  flex: 1;
  height: 42px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.18s ease;
  letter-spacing: 0.01em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dc-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dc-btn--cancel {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.dc-btn--cancel:hover:not(:disabled) {
  background: #e2e8f0;
  color: #1e293b;
}

.dc-btn--confirm {
  background: #e5252a;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(229, 37, 42, 0.25);
}

.dc-btn--confirm:hover:not(:disabled) {
  background: #c91e23;
  box-shadow: 0 4px 12px rgba(229, 37, 42, 0.35);
  transform: translateY(-1px);
}

/* Spinner de carga */
.dc-spinner {
  width: 18px;
  height: 18px;
  border: 2.5px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: dc-spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes dc-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
